import './AccessStatisticsSection.scss';

import { NoData } from '@ui/NoData';
import { SonarText } from '@ui/text';

import { COPY_SPECIFIC, DATA_SECURITY_DASHBOARD } from '@sonar-software/sonar-ts-constants';
import React, { PropsWithChildren } from 'react';

const sectionLabels = {
	applications: COPY_SPECIFIC.APPLICATIONS,
	entities: COPY_SPECIFIC.ENTITIES,
	fields: COPY_SPECIFIC.FIELDS
};

export interface AccessStatisticsSectionProps{
	hide?: boolean;
	isEmpty: boolean;
	section: keyof typeof sectionLabels;
}

export const AccessStatisticsSection : React.FC<PropsWithChildren<AccessStatisticsSectionProps>> = ({
	children,
	hide,
	isEmpty,
	section
}) => {
	if (hide) {
		return null;
	}

	const countSource = section === 'applications' ? DATA_SECURITY_DASHBOARD.CALLS : DATA_SECURITY_DASHBOARD.REQUESTS;
	const topFiveRequests = `Top 5 ${sectionLabels[ section ]} by ${countSource}`;

	return (
		<div className='access-statistics-section'>
			<SonarText
				className='top-five-title'
				weight='semibold'>{ topFiveRequests }
			</SonarText>
			<div className='column-headers'>
				<SonarText weight='semibold'>{ sectionLabels[ section ] }</SonarText>
				<SonarText weight='semibold'>{ countSource }</SonarText>
			</div>
			<div className='statistics-rows'>
				{ isEmpty ? <NoData /> : children }
			</div>
		</div>
	);
};
